<template>
  <div class="submitted-offer-small">
    <div class="row">
      <div class="d-none d-lg-block col-lg-3 submitted-offer-small-logo"><img :src="logoURL" v-if="logoURL" /></div>
      <div class="col-7 submitted-offer-small-title">{{title}}</div>
      <div class="col-5 col-lg-2 red-x" v-if="offer.status !== 'Accepted'">
        X
      </div>
      <div class="col-5 col-lg-2 green-check" v-else>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-check2-square" viewBox="0 0 16 16">
          <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/>
          <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
        </svg>
      </div>
    </div>
    <div class="row" v-show="offer.status !== 'Accepted'">
      <div class="col-auto offer-status">
        <ul v-if="typeof status === 'string'">
          <li>
            {{status}}
          </li>
        </ul>
        <template v-else>
          <ul>
            <li v-for="(subReason, index) in status" :key="index">
            {{subReason}}
            </li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SubmittedOfferSmall',
  props: ['offer'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    logoURL () {
      return this.offer.offer.logoURL
    },
    title () {
      return this.offer.offer.name
    },
    subjects () {
      return this.offer.offer.subjects
    },
    status () {
      return this.offer.status !== 'Accepted' ? this.offer.errors[''] ? this.offer.errors[''] : this.offer.errors : 'status: Accepted'
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.submitted-offer-small {
  padding-top: 10px;
}
.submitted-offer-small-logo img {
  max-width: 100%;
  max-height: 45px;
  width: auto;
  height: auto;
}
.red-x {
  text-align: right;
  color: darkred;
  font-weight: 900;
  font-size: 24px;
  margin-left: -10px;
}
.green-check {
  color: #3c763d;
}
.green-check svg {
  height: 40px;
  margin-top: -2px;
  float: right;
}
</style>
